import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import DashboardListFetching from "./DashboardListFetching";
import NotFoundV2 from "../NotFound/NotFoundV2";
import Item from "./Item";
import { NotificationManager } from "react-notifications";
import _ from "i18n";
import {
  deleteDashboard,
  duplicateDashboard,
  fetchAvailableDashboard,
  updateDashboardState,
  updatePrivacyDashboard,
  setDashboardPrivate,
  useSharedDashboard
} from "Thunks";
import { setDashboardSelectedItem, setDashboardIsEditable } from "Actions";
import { ModalConfirm } from "tamtam-components";

class DashboardList extends Component {
  // ****  Balance Upload Modal (functions) **** //
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      slide: 1,
      DashboardId: null,
      isOpenModalDelete: false,
      isOpenModal: false,
      id: null,
      isOpenModalShare: false,
      isOpenModalState: false,
      isOpenModalPrivatize: false,
      isOpenModalUsingSharedDashboard: false
    };
    this.setSelectedDashboardId = this.setSelectedDashboardId.bind(this);
    this.carousel = React.createRef();
  }
  handleDuplicateDashboard = id => {
    this.setState({ isOpenModal: true });
    this.setState({ id: id });
  };
  handleDeleteDashboard = id => {
    this.setState({ isOpenModalDelete: true });
    this.setState({ id: id });
  };
  handleStateDashboard = id => {
    this.setState({ isOpenModalState: true });
    this.setState({ id: id });
  };
  handleUseSharedDashboard = id => {
    this.setState({ isOpenModalUsingSharedDashboard: true });
    this.setState({ id: id });
  };
  handleShareDashboard = (id, isEditable) => {
    this.setState({ isOpenModalShare: true });
    this.setState({ id: id });
    this.props.dispatch(setDashboardIsEditable(isEditable));
  };
  handleSetDashboardPrivacy = id => {
    this.setState({ isOpenModalPrivatize: true });
    this.setState({ id: id });
  };
  onSuccess(res, msg) {
    NotificationManager.success(
      _("dashboardDeleted"),
      _("deleteDashboardSuccess")
    );
  }

  onFailure(err) {
    if (err.response.data.errors[0].code === 1700126) {
      NotificationManager.error(
        _("dashboardAlreadyUsedDeleteError"),
        _("error")
      );
      this.setState({ isOpenModalDelete: false });
    } else if (err.response.data.errors[0].code === 1700123) {
      NotificationManager.error(_("dashboardAlreadyUsed"), _("error"));
      this.setState({ isOpenModalPrivatize: false });
    } else {
      NotificationManager.error(_("incompleteOperation"), _("error"));
    }
  }
  setSelectedDashboardId(dashboardId) {
    this.setState({
      dashboardId: dashboardId
    });
  }

  handleSelectDashboard = id => {
    let { selectedDashboards } = this.props;

    let newSelectedDashboards = [...selectedDashboards];
    if (newSelectedDashboards.includes(id)) {
      newSelectedDashboards.splice(newSelectedDashboards.indexOf(id), 1);
    } else {
      newSelectedDashboards.push(id);
    }
    this.props.dispatch(setDashboardSelectedItem(newSelectedDashboards));
  };

  handleDisplayUpdateDashboard = ({ dashboard }) => {
    this.props.dispatch(push(`/composition/dashboard/${dashboard.id}`));
  };
  handleDisplayDashboardSlides = ({ dashboard }) => {
    this.props.onDisplayDashboardSlides(dashboard);
  };

  handleRedirectToDashboard = ({ dashboard }) => {
    return;
  };

  onChangeIsEditable = () => {
    const {
      dispatch,
      composition: { isEditable }
    } = this.props;
    dispatch(setDashboardIsEditable(isEditable ? 0 : 1));
  };

  render() {
    let { dashboards } = this.props;
    const {
      fetching,
      fetched,
      selectedDashboards,
      saving,
      saved,
      dispatch,
      selectedFilterValue,
      withoutHeader,
      newTag,
      closeNewTag,
      composition: { isEditable }
    } = this.props;
    let {
      isOpenModalDelete,
      isOpenModal,
      id,
      isOpenModalShare,
      isOpenModalState,
      isOpenModalPrivatize,
      isOpenModalUsingSharedDashboard
    } = this.state;
    let items = [];
    let limit =
      dashboards.length < 5 && dashboards.length > 0
        ? 5 - dashboards.length
        : 0;
    for (let i = 0; i < limit; i++) {
      items.push(
        <div className={"medium-4"} style={{ opacity: 0 }}>
          <Item
            key={`dashboard-${dashboards[0].id}`}
            dashboard={dashboards[0]}
            {...dashboards[0]}
            selected={selectedDashboards.includes(dashboards[0].id)}
            handleSelectDashboard={this.handleSelectDashboard}
            handleDisplayUpdateDashboard={this.handleDisplayUpdateDashboard}
            deleteDashboard={this.handleDeleteDashboard}
            redirectToDashboard={this.handleRedirectToDashboard}
            duplicateDashboard={this.handleDuplicateDashboard}
            shareDashboard={this.handleShareDashboard}
            handleSetDashboardPrivacy={this.handleSetDashboardPrivacy}
            updateStateDashboard={this.handleStateDashboard}
            handleUseSharedDashboard={this.handleUseSharedDashboard}
            selectedFilterValue={selectedFilterValue}
            newTag={newTag}
            closeNewTag={closeNewTag}
          />
        </div>
      );
    }

    // if (fetching || saving) {
    if (fetching) {
      return <DashboardListFetching withoutHeader={withoutHeader} />;
    }
    return (
      <div className="row medium-11">
        {saved || (fetched && dashboards.length) ? (
          <div className="row medium-12">
            {dashboards.map((item, i) => {
              return (
                <Item
                  key={`dashboard-${item.id}`}
                  dashboard={item}
                  {...item}
                  selected={selectedDashboards.includes(item.id)}
                  handleSelectDashboard={this.handleSelectDashboard}
                  handleDisplayUpdateDashboard={
                    this.handleDisplayUpdateDashboard
                  }
                  deleteDashboard={this.handleDeleteDashboard}
                  displayDashboardSlides={this.handleDisplayDashboardSlides}
                  redirectToDashboard={this.handleRedirectToDashboard}
                  duplicateDashboard={this.handleDuplicateDashboard}
                  shareDashboard={this.handleShareDashboard}
                  handleSetDashboardPrivacy={this.handleSetDashboardPrivacy}
                  updateStateDashboard={this.handleStateDashboard}
                  handleUseSharedDashboard={this.handleUseSharedDashboard}
                  selectedFilterValue={selectedFilterValue}
                  newTag={newTag}
                  closeNewTag={closeNewTag}
                />
              );
            })}
            {items}
          </div>
        ) : (
          <NotFoundV2 />
        )}
        <ModalConfirm
          type={"delete"}
          isOpen={isOpenModalDelete}
          onCancel={() => this.setState({ isOpenModalDelete: false })}
          onConfirm={() => {
            dispatch(deleteDashboard(id)).then(
              res => {
                this.onSuccess(res);
                dispatch(fetchAvailableDashboard());
                this.setState({ isOpenModalDelete: false });
              },
              err => this.onFailure(err)
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("deleteConfirm")}
          text={_("deleteConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("delete")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"duplicate"}
          isOpen={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
          onConfirm={() => {
            dispatch(duplicateDashboard(id)).then(
              res => {
                dispatch(fetchAvailableDashboard());
                // this.props.dispatch(push(`/dashboards`));
                NotificationManager.success(
                  _("dashboardDuplicated"),
                  _("duplicateDashboardSuccess")
                );
                this.setState({ isOpenModal: false });
              },
              err => {
                this.onFailure(err);
              }
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("titleDuplicateDashboard")}
          text={_("duplicateDashboardContent")}
          labelNo={_("cancel")}
          labelYes={_("duplicate")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"share"}
          isOpen={isOpenModalShare}
          isChecked={isEditable}
          onCancel={() => this.setState({ isOpenModalShare: false })}
          onConfirm={() => {
            dispatch(
              updatePrivacyDashboard(id, isEditable === false ? 0 : 1)
            ).then(
              res => {
                dispatch(fetchAvailableDashboard());
                // this.props.dispatch(push(`/dashboards`));
                NotificationManager.success(
                  _("dashboardShared"),
                  _("dashboardSharedSuccess")
                );
                this.setState({ isOpenModalShare: false });
              },
              err => {
                this.onFailure(err);
              }
            );
          }}
          onSwitch={() => this.onChangeIsEditable()}
          inProcess={false}
          actionFailed={false}
          title={_("titleSharedDashboard")}
          text={_("sharedDashboardContent")}
          secondText={_("editableTemplate")}
          labelNo={_("cancel")}
          labelYes={_("share")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"privatize"}
          isOpen={isOpenModalPrivatize}
          onCancel={() => this.setState({ isOpenModalPrivatize: false })}
          onConfirm={() => {
            dispatch(setDashboardPrivate(id)).then(
              res => {
                dispatch(fetchAvailableDashboard());
                NotificationManager.success(
                  _("titleVisibilityDashboard"),
                  _("dashboardPrivateSuccess")
                );
                this.setState({ isOpenModalPrivatize: false });
              },
              err => {
                this.onFailure(err);
              }
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("titleVisibilityDashboard")}
          text={_("visibilityDashboardContent")}
          labelNo={_("no")}
          labelYes={_("yes")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"add"}
          isOpen={isOpenModalState}
          onCancel={() => this.setState({ isOpenModalState: false })}
          onConfirm={() => {
            dispatch(updateDashboardState(id)).then(
              res => {
                dispatch(fetchAvailableDashboard());
                // this.props.dispatch(push(`/dashboards`));
                NotificationManager.success(
                  _("dashboardAdded"),
                  _("addDashboardSuccess")
                );
                this.setState({ isOpenModalState: false });
              },
              err => {
                this.onFailure(err);
              }
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("titleAddDashboard")}
          text={_("addDashboardContent")}
          labelNo={_("cancel")}
          labelYes={_("add")}
          labelError={"Error"}
        />
        <ModalConfirm
          type={"add"}
          isOpen={isOpenModalUsingSharedDashboard}
          onCancel={() =>
            this.setState({ isOpenModalUsingSharedDashboard: false })
          }
          onConfirm={() => {
            dispatch(useSharedDashboard(id)).then(
              res => {
                dispatch(fetchAvailableDashboard());
                NotificationManager.success(
                  _("dashboardAdded"),
                  _("addDashboardSuccess")
                );
                this.setState({ isOpenModalUsingSharedDashboard: false });
              },
              err => {
                this.onFailure(err);
              }
            );
          }}
          inProcess={false}
          actionFailed={false}
          title={_("titleUseSharedDashboard")}
          text={_("useSharedDashboardContent")}
          labelNo={_("cancel")}
          labelYes={_("use")}
          labelError={"Error"}
        />
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  fetching: state.dashboardList.fetching,
  fetched: state.dashboardList.fetched,
  saving: state.dashboardList.saving,
  saved: state.dashboardList.saved,
  dashboard: state.dashboardList.items,
  selectedDashboards: state.dashboardList.selected,
  composition: state.dashboardComposition.composition,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(DashboardList);



// WEBPACK FOOTER //
// ./src/components/DashboardList/DashboardList.js